import { Nav, Box, Paragraph, Badge } from '@landr/maestro';
import React from 'react';

var BadgeTitle = function BadgeTitle(_ref) {
  var content = _ref.content;
  if (content) {
    return /*#__PURE__*/React.createElement(Box, {
      ml: "xs"
    }, /*#__PURE__*/React.createElement(Badge, {
      size: "sm",
      variant: "secondary",
      content: content
    }));
  }
  return null;
};
var NavBarItem = function NavBarItem(_ref2) {
  var onClick = _ref2.onClick,
    icon = _ref2.icon,
    title = _ref2.title,
    subTitle = _ref2.subTitle,
    href = _ref2.href,
    badgeTitle = _ref2.badgeTitle;
  return /*#__PURE__*/React.createElement(Nav.DropdownItem, {
    as: "a",
    onClick: onClick,
    href: href
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    mr: "md"
  }, icon), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Paragraph, {
    m: "0"
  }, title)), /*#__PURE__*/React.createElement(BadgeTitle, {
    content: badgeTitle
  })), /*#__PURE__*/React.createElement(Paragraph, {
    contrast: "low",
    m: "0",
    size: "sm"
  }, subTitle))));
};

export { NavBarItem };
